import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CallUsComponent } from '@app/shared/customer-service/call-us/call-us.component';
import { ChatbotModule } from '@app/shared/customer-service/chatbot/chatbot/chatbot.module';
import { ChatbotFixedModule } from './chatbot/chatbot-fixed/chatbot-fixed.module';
import { ChatbotModalModule } from './chatbot/chatbot-modal/chatbot-modal.module';
import { FaqModule } from './faq/faq.module';

/** @deprecated - this is moved to libs */
@NgModule({
    declarations: [
        CallUsComponent,
    ],
    imports: [
        CommonModule,
        ChatbotModule,
        ChatbotModalModule,
        ChatbotFixedModule,
        FaqModule,
    ],
    exports: [
        ChatbotModule,
        ChatbotModalModule,
        ChatbotFixedModule,
        CallUsComponent,
        FaqModule,
    ],
})
export class CustomerServiceModule {
}
